import type { NavApp } from './constants';

export interface NavTarget {
  lat?: number | null;
  lng?: number | null;
  address?: string | null;
}

/**
 * Turn-by-turn navigation link for the user's chosen app. Coordinates are more
 * precise than an address, so they win when known. Returns null when there is
 * nothing to navigate to.
 */
export function navigationUrl(app: NavApp, target: NavTarget): string | null {
  const hasCoords = target.lat != null && target.lng != null;
  const address = target.address?.trim();
  if (!hasCoords && !address) return null;
  const coords = hasCoords ? `${target.lat},${target.lng}` : '';
  const q = encodeURIComponent(address ?? '');

  switch (app) {
    case 'waze':
      return hasCoords ? `https://waze.com/ul?ll=${coords}&navigate=yes` : `https://waze.com/ul?q=${q}&navigate=yes`;
    case 'apple':
      return `https://maps.apple.com/?daddr=${hasCoords ? coords : q}&dirflg=d`;
    case 'google':
    default:
      return `https://www.google.com/maps/dir/?api=1&destination=${hasCoords ? coords : q}&travelmode=driving`;
  }
}
